module.exports = __webpack_public_path__ + "img/chess-clock-flip.f84d80ba.svg";